
// Keep ALL pricing logic here so it's consistent everywhere.

// If you want VAT etc later, you can expand this to return { net, vat, gross }.
const CHECK_PRICES = Object.freeze({
  SIMPLE: 1.2, // <-- set your real prices
  "PEP & SANCTIONS": 0.60,
  PEP: 0.60,
  SANCTIONS: 0.60,
  STANDARD: 1.2,
  ENHANCED: 2.4,
  // Add any other custom types you store in Firestore:
  // "DATABASE VERIFICATION": 0,
});

const clean = (v) => String(v ?? "").trim();

function normaliseCheckType(checkType) {
  const t = clean(checkType);
  const upper = t.toUpperCase();

  // Robust normalisation (handles common variations)
  if (upper.includes("SIMPLE")) return "SIMPLE";
  if (upper.includes("PEP")) return "PEP & SANCTIONS"; // or "PEP" if you price separately
  if (upper.includes("SANCTION")) return "PEP & SANCTIONS";
  if (upper.includes("STANDARD")) return "STANDARD";
  if (upper.includes("ENHANCED")) return "ENHANCED";

  // fallback: try direct match by cleaned string
  return t || "UNKNOWN";
}

function getCheckPrice(checkType) {
  const key = normaliseCheckType(checkType);
  return Number(CHECK_PRICES[key] ?? 0);
}

// function formatGBP(amount) {
//     const n = Number(amount ?? 0);
//     return Number.isFinite(n) ? n.toFixed(2) : "0.00";
// }
function formatGBP(amount) {
  const n = Number(amount ?? 0);
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(n) ? n : 0);
}

module.exports = { CHECK_PRICES, normaliseCheckType, getCheckPrice, formatGBP };
